import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ptBR from "./locales/pt-BR.json";
import enUS from "./locales/en-US.json";
import esES from "./locales/es-ES.json";
import { normalizeLocale } from "../../shared/plans.js";

const urlLang = new URLSearchParams(window.location.search).get("app_language");
const fallback = "pt-BR";
const lang = normalizeLocale(urlLang ?? fallback);

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      "pt-BR": { translation: ptBR },
      "en-US": { translation: enUS },
      "es-ES": { translation: esES },
    },
    lng: lang,
    fallbackLng: fallback,
    interpolation: { escapeValue: false },
  });

document.documentElement.lang = lang;

export default i18n;
